export class PersonBase {
  id?: string;
  name?: string;
  addressText?: string;
  cityText?: string;
  emailText?: string;
}
